import { getEpisodeCategories } from "api/functions/functions"
import { Button, ComposedModal, DataTable, FormGroup, ModalHeader, MultiSelect, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow, TableSelectAll, TableSelectRow, TableToolbar, TableToolbarContent, TableToolbarSearch } from "carbon-components-react"
import MainContext from "context/MainContext"
import { useState, useEffect, useContext } from "react"
import _ from "lodash";
import EpisodeCategoryForm from "forms/EpisodeCategoryForm/EpisodeCategoryForm";
import { consoleLog } from "utils/functions";

const TagList = (props) => {

    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(true)
    const [init, setInit] = useState()
    const [initValue, setInitValue] = useState()
    const [rowsData, setRowsData] = useState([])
    const [modalFormOpen, setModalFormOpen] = useState(false);
    const [modalItem, setModalItem] = useState();
    const [ids, setIds] = useState([]);

    const context = useContext(MainContext)

    useEffect(() => {
        const defaultValue = props.defaultValue || []
        setInitValue(defaultValue)
        setSelected(defaultValue)
    }, [props.defaultValue])

    useEffect(() => {
        if (!init && context.evt) {
            loadList()
        }
    }, [context.evt, init])

    const loadList = async () => {
        setLoading(true)
        try {
            const res = await getEpisodeCategories(context.evt.id)
            setRowsData(res)
            setIds(res.map((item) => item.id))
        }
        catch (e) { }
        finally {
            setLoading(false)
            setInit(true)
        }
    }

    const toggleRow = (value, row) => {

        let newSelected = [...selected]
        if (value) {
            newSelected.push(row.id)
        } else {
            newSelected = newSelected.filter((item) => item !== row.id)

        }
        // setToggled(toggled => [...toggled].concat(row.id))
        setSelected(newSelected)
        props.onChange(newSelected);
    };

    const toggleAll = (e, selectedRows) => {
        // console.log("toggleAll", e.target.checked, selectedRows)
        let newSelected = []
        if (e.target.checked && selectedRows.length === 0) {
            newSelected = ids
        } else {
            newSelected = [];
        }
        setSelected(newSelected)
        // console.log("toggleAll new Selected", newSelected)
        props.onChange(newSelected);
    };

    const openModalForm = (selectedItem) => {
        let modalItem = null
        if (selectedItem) {
            modalItem = rowsData.find(item => selectedItem === item.id)
        }
        console.log("modalItem", modalItem, selectedItem)
        setModalItem(modalItem)
        setModalFormOpen(true)
    }

    const closeModalForm = () => {
        setModalItem()
        setModalFormOpen(false)
    }

    const rowsFormattedData = () => {
        return rowsData.map(item => {
            return {
                ...item,
                output: `${item.title_default} (#${item.id})`,
                isSelected: (!_.isEmpty(selected)) ? selected.includes(item.id) : false,
            }
        })
    }

    return (
        <>
            <FormGroup legendText={props.labelText}>
                {
                    loading ? "Loading..." : (
                        <DataTable
                            rows={rowsFormattedData()}
                            headers={[
                                {
                                    header: 'Title',
                                    key: 'output',
                                }
                            ]}
                            stickyHeader={true}
                            size="short">
                            {({
                                rows,
                                headers,
                                getTableProps,
                                getRowProps,
                                getSelectionProps,
                                getHeaderProps,
                                onInputChange,
                                getBatchActionProps,
                                selectedRows
                            }) => {
                                const selectionProps = getSelectionProps();
                                const newSelectionProps = {
                                    ...selectionProps,
                                    onSelect: (e) => {
                                        toggleAll(e, selectedRows);
                                        selectionProps.onSelect(e);
                                    },
                                };
                                return (
                                    <TableContainer>
                                        <TableToolbar>
                                            <TableToolbarContent>
                                                <TableToolbarSearch
                                                    persistent={true}
                                                    tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                                    onChange={onInputChange}
                                                />
                                            </TableToolbarContent>
                                            <Button
                                                tabIndex={getBatchActionProps().shouldShowBatchActions ? -1 : 0}
                                                onClick={openModalForm}
                                                size="small"
                                                kind="primary"
                                            >
                                                Add new
                                            </Button>
                                        </TableToolbar>
                                        {
                                            rowsData.length ? (
                                                <Table {...getTableProps()}>
                                                    <TableHead>
                                                        <TableRow>
                                                            {/* <TableExpandHeader /> */}
                                                            <TableSelectAll
                                                                {...newSelectionProps}
                                                            />
                                                            {headers.map((header) => (
                                                                <TableHeader {...getHeaderProps({ header })}>
                                                                    {header.header}
                                                                </TableHeader>
                                                            ))}
                                                            <TableHeader></TableHeader>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {rows.map((row) => (
                                                            <TableRow {...getRowProps({ row })}>
                                                                <TableSelectRow
                                                                    {...getSelectionProps({ row })}
                                                                    // checked={selected.indexOf(row.id) !== -1}
                                                                    onChange={(e) => toggleRow(e, row)}
                                                                />
                                                                {row.cells.map((cell) => (
                                                                    <TableCell key={cell.id}>{cell.value}</TableCell>
                                                                ))}
                                                                <TableCell style={{ textAlign: "right" }}>
                                                                    <a onClick={() => openModalForm(row.id)}>
                                                                        {"Edit"}
                                                                    </a>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            ) : (
                                                <div>The list is empty</div>
                                            )
                                        }
                                    </TableContainer>
                                )
                            }}
                        </DataTable>
                    )
                }
            </FormGroup>
            <ComposedModal
                size='sm'
                open={modalFormOpen}
                onClose={closeModalForm}
            >
                <ModalHeader
                    title={modalItem !== undefined ? "Edit episode category" : "Add new episode category"}
                />
                <EpisodeCategoryForm
                    modal={true}
                    abortButton={true}
                    item={modalItem}
                    onAbortClicked={closeModalForm}
                    onSubmit={loadList}
                />
            </ComposedModal>
        </>
    )
}

export default TagList